var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.408 3.862a.496.496 0 00.696-.009.504.504 0 00-.007-.716L8.438 1.53a.663.663 0 00-.942 0l-1.6 1.61a.505.505 0 00.019.727c.197.18.5.172.688-.017l.897-.903v7.886a.5.5 0 001 0V2.99l.908.872zm-5.741 9.805h8.667V6.333h-1.667v-1h2c.368 0 .667.299.667.667v8a.667.667 0 01-.667.667H3.334A.667.667 0 012.667 14V6c0-.368.299-.667.667-.667h2v1H3.667v7.334z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpload);
export default new URL("/builds/software-solutions/workspace/web/eagleid-fe-workspace/src/images/iconUpload.svg", import.meta.url).toString();
export { ForwardRef as ReactComponent };